import React from "react";
import Module from "./Module";
import {
  FormControl,
  FormGroup,
  Input,
  ColorPicker,
  CustomText,
  Icon,
  Switch,
} from "components";
import classNames from "lib/classNames";
const CheckoutButton = (props) => {
  const { context, setCheckoutButtonLoadingEdit } = props;
  const { state, validationErrors } = context;
  // <Module name="Checkout Section" {...{ ...props, reset: !!hasCheckout }}>
  // 	<>
  // 		{!!hasCheckout && (
  return (
    <>
      <FormGroup
        label="Checkout Button"
        info="Keep these settings simple and to the point"
        fullWidth
      >
        <CustomText
          context={context}
          label="Subtotal"
          hasColor={true}
          path="settings.modules.checkout_button.subtotal"
          hasWeight="700"
        />
        <CustomText
          context={context}
          label="Savings"
          hasColor={true}
          path="settings.modules.checkout_button.savings"
          hasWeight="700"
        />
        <FormControl
          label="Checkout as Link"
          withSwitch={[
            context,
            "settings.modules.checkout_button.checkout_as_link",
          ]}
          info="Turn the checkout button into a link"
          className={"mb-6"}
        />
        <CustomText
          context={context}
          placeholder="checkout"
          hasColor={true}
          label="checkout button text"
          path="settings.modules.checkout_button.button_text"
          hasWeight="700"
        />
        <CustomText
          context={context}
          placeholder="processing"
          hasColor={true}
          hasNumber={false}
          onFocus={() => setCheckoutButtonLoadingEdit(true)}
          onBlur={() => setCheckoutButtonLoadingEdit(false)}
          label="checkout button loading text"
          path="settings.modules.checkout_button.button_text_loading"
        />
        <FormControl label="checkout button colors">
          <ColorPicker
            text="background"
            BindToContext={[
              context,
              "settings.modules.checkout_button.background",
            ]}
          />
          {/* <ColorPicker
						text="hover background"
						BindToContext={[context, 'settings.modules.checkout_button.hoverBackground']}
					/> */}
        </FormControl>
        <FormControl
          label="Continue Shopping Button"
          info="Make it easy for customers to continue shopping"
          withSwitch={[
            context,
            "settings.modules.checkout_button.active_continue_shopping_button",
          ]}
        >
          {state.settings.modules.checkout_button
            .active_continue_shopping_button && (
            <CustomText
              context={context}
              placeholder="Continue shopping"
              hasColor={true}
              path="settings.modules.checkout_button.continue_shopping_button"
            />
          )}
        </FormControl>
        {state.settings.modules.checkout_button
          .active_continue_shopping_button && (
          <FormControl
            label="Underline link"
            withSwitch={[
              context,
              "settings.modules.checkout_button.active_continue_shopping_underlined",
            ]}
          ></FormControl>
        )}

        {state.settings.cod_settings.is_active && (
          <>
            <FormControl label="COD checkout button colors">
              <ColorPicker
                text="background"
                BindToContext={[
                  context,
                  "settings.cod_settings.checkout_button.background",
                ]}
              />
              {/* <ColorPicker
								text="hover background"
								BindToContext={[context, 'settings.cod_settings.checkout_button.hoverBackground']}
							/> */}
            </FormControl>
            <CustomText
              context={context}
              label="COD checkout button"
              hasColor={true}
              path="settings.cod_settings.checkout_button"
            />
          </>
        )}
      </FormGroup>
      <FormGroup
        label="coupon code form"
        info={`The cart allows discounts codes to be entered.
				If a discount code is activated all other cart discounts are dismissed.`}
        fullWidth
      >
        <CustomText
          context={context}
          label="Use Coupon Code"
          hasColor={true}
          path="settings.modules.checkout_button.use_coupon_code"
          withSwitch={[context, "settings.show_coupon"]}
          marginBottom="mb-4"
          beta
        />
        <div className={classNames("flex flex-wrap -mx-2")}>
          <CustomText
            context={context}
            className="px-2 flex-1 w-auto"
            label="Edit Coupon Code"
            path="settings.modules.checkout_button.edit_coupon_code"
          />
          <CustomText
            context={context}
            className="px-2 flex-1 w-auto"
            label="Close Coupon Code"
            path="settings.modules.checkout_button.close_coupon_code"
          />
        </div>
        <CustomText
          context={context}
          label="Enter Coupon Code"
          hasColor={true}
          path="settings.modules.checkout_button.enter_coupon_code"
        />
        <CustomText
          context={context}
          label="Apply Coupon Code"
          hasColor={true}
          path="settings.modules.checkout_button.apply_coupon_code"
        />
        <CustomText
          context={context}
          label="Coupon Code Alert"
          withSwitch={[context, "settings.show_coupon_alert_text"]}
          hasColor={true}
          path="settings.modules.checkout_button.coupon_alert_text"
        />
        <FormControl label="apply coupon button colors">
          <ColorPicker
            text="background"
            BindToContext={[
              context,
              "settings.modules.checkout_button.coupon.background",
            ]}
          />
          {/* <ColorPicker
                        text="hover background"
                        BindToContext={[
                            context,
                            'settings.modules.checkout_button.coupon.hoverBackground'
                        ]}
                    /> */}
        </FormControl>
      </FormGroup>
    </>
  );
};

export default CheckoutButton;
